import React from 'react';
import { TableRow as MuiTableRow } from '@material-ui/core';

const TableRow = props => <MuiTableRow {...props} />;

export default TableRow;
